import AlertIcon from './SendIconRed.svg'
const ActiveIcon = () => {
    return (
      <img src={AlertIcon} alt='error' />
    )
}
export default ActiveIcon